import React from "react";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import { useCabinetSummary } from "features/cabinet-tasks/use-cabinet-summary";

/** «Turtas | Prašymai (N)» strip over the assets list and the asset requests queue. */
export default function AssetsTabs({ companyId }: { companyId: string }) {
  const { t } = useTranslation();
  // The same number as the Turtas menu item: pending requests, from the cabinet summary.
  const pendingCount = useCabinetSummary(companyId).summary?.queues.assetRequests?.count ?? 0;
  const tabClass = ({ isActive }: { isActive: boolean }) =>
    clsx(
      "-mb-px border-b-2 px-3 py-2 text-sm font-medium",
      isActive
        ? "border-blue-600 text-blue-700"
        : "border-transparent text-gray-600 hover:border-gray-300 hover:text-gray-900"
    );
  return (
    <nav className="mb-4 flex gap-2 border-b border-gray-200" aria-label={t("assets")}>
      <NavLink to={`/app/${companyId}/assets`} end className={tabClass}>
        {t("asset_requests_tab_assets")}
      </NavLink>
      <NavLink to={`/app/${companyId}/assets/requests`} className={tabClass}>
        {t("asset_requests_tab_requests")}
        {pendingCount > 0 && ` (${pendingCount})`}
      </NavLink>
    </nav>
  );
}
